export const roleBadgeClassMap = {
    ADMIN: 'bg-soft-primary text-primary',
    USER: 'bg-soft-info text-info',
    GUEST: 'bg-soft-warning text-warning',
};

export const statusClassMap = {
    true: 'bg-soft-success text-success',
    false: 'bg-soft-danger text-danger',
};

export const searchFieldOptions = [
    { value: 'email', label: 'Email' },
    { value: 'name', label: 'Nombre' },
    { value: 'firstName', label: 'Nombre (simple)' },
    { value: 'lastName', label: 'Apellido' },
    { value: 'role', label: 'Rol' },
];

export const statusOptions = [
    { value: 'ALL', label: 'Todos' },
    { value: 'ACTIVE', label: 'Activos' },
    { value: 'INACTIVE', label: 'Inactivos' },
];

export const searchFieldLabelMap = {
    email: 'Email',
    name: 'Nombre',
    firstName: 'Nombre (simple)',
    lastName: 'Apellido',
    role: 'Rol',
};

